<div class="formulario-beneficiario-container">
  <div class="formulario-header">
    <h3 class="titulo-formulario">Solicitud de Bebé Gestante</h3>
  </div>
  <nz-spin [nzSpinning]="enviando">
  <form nz-form [formGroup]="beneficiarioForm" class="formulario-beneficiario">
    
    <!-- Fecha Inicio -->
    <nz-form-item>
      <nz-form-label nzFor="fechaInicio" nzRequired>Fecha de Inicio</nz-form-label>
      <nz-form-control nzErrorTip="Por favor seleccione la fecha de inicio">
        <nz-date-picker 
          formControlName="fechaInicio"
          nzId="fechaInicio"
          nzFormat="yyyy-MM-dd"
          nzPlaceHolder="Seleccionar fecha de inicio"
          [nzAllowClear]="false"
          [nzDisabledDate]="disabledDate"
          class="red-date-picker"
          style="width: 100%;">
        </nz-date-picker>
      </nz-form-control>
    </nz-form-item>



    <!-- Colaborador es Gestante -->
    <!-- <nz-form-item>
      <nz-form-label nzFor="colaboradorEsGestante">¿Usted se encuentra en estado de Embarazo?</nz-form-label>
      <nz-form-control>
        <nz-radio-group formControlName="colaboradorEsGestante" nzId="colaboradorEsGestante">
          <label nz-radio [nzValue]="true">Sí</label>
          <label nz-radio [nzValue]="false">No</label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item> -->

    <!-- Beneficiario ID -->
    <nz-form-item *ngIf="beneficiarioForm.get('colaboradorEsGestante')?.value == false">
      <nz-form-control nzErrorTip="Por favor seleccione un beneficiario">
        <!-- <nz-form-label nzFor="beneficiarioId">Seleccione el beneficiario en estado de embarazo</nz-form-label> -->
        <nz-select 
          formControlName="beneficiarioId"
          nzId="beneficiarioId"
          nzPlaceHolder="No existe un beneficiario registrado que pueda obtener este beneficio"
          nzShowSearch
          nzAllowClear
          [nzDisabled]="beneficiarioDisabled"
          style="width: 100%;">
          <nz-option 
            *ngFor="let beneficiario of beneficiarios" 
            [nzValue]="beneficiario.id" 
            [nzLabel]="beneficiario?.nombres + ' ' + beneficiario?.apellidos + ' - ' + beneficiario?.parentescoNombre">
          </nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Número de Gestantes -->
    <nz-form-item>
      <nz-form-label nzFor="numeroFetos" nzRequired>Número de Gestantes</nz-form-label>
      <nz-form-control nzErrorTip="Por favor ingrese el número">
        <input
          nz-input
          formControlName="numeroFetos"
          nzId="numeroFetos"
          type="number"
          min="1"
          nzPlaceHolder="Ingrese el número"
          style="width: 100%;">
      </nz-form-control>
    </nz-form-item>

    <!-- Upload de Archivos -->
    <nz-form-item>
      <nz-form-label nzFor="archivos" nzRequired>Subir Archivos</nz-form-label>
      <nz-form-control>
        <nz-upload 
          nzMultiple
          [(nzFileList)]="fileList"
          [nzBeforeUpload]="beforeUpload"
          (nzChange)="handleChange($event)"
          class="upload-archivos">
          <button nz-button nzType="default">
            <i nz-icon nzType="upload"></i>
            Seleccionar Archivos
          </button>
        </nz-upload>
      </nz-form-control>
    </nz-form-item>

    <!-- Botones de Acción -->
    <nz-form-item class="botones-container">
      <nz-form-control>
        <div class="botones-accion">
          <button 
            nz-button 
            nzType="primary"
            class="boton-enviar"
            [nzLoading]="enviando"
            [disabled]="!beneficiarioForm.valid"
            (click)="submit()">
            Aceptar
          </button>
        </div>
      </nz-form-control>
    </nz-form-item>

  </form>
  </nz-spin>
</div>
